module.exports = __webpack_public_path__ + "static/media/type-6.031f9467.svg";